export const CREATOR_PROGRAM_SUBJECT = "Creator Program"

export const CUSTOM_BUILD_SUBJECT = "Custom Build"

export const CONTACT_SUBJECTS = [
  "General Inquiry",
  "Technical Support",
  "Product Question",
  CREATOR_PROGRAM_SUBJECT,
  "Partnership",
  CUSTOM_BUILD_SUBJECT,
  "Feedback",
  "Other",
] as const

export type ContactSubject = (typeof CONTACT_SUBJECTS)[number]

export function getContactSubjectFromSearchParam(value: string | null): ContactSubject | "" {
  if (!value) return ""
  return CONTACT_SUBJECTS.includes(value as ContactSubject) ? (value as ContactSubject) : ""
}

// Entry points the contact form tags on the support email and Discord card, so
// feedback from them can be filtered. `quick_action_delete` is the mobile
// "Why delete us?" Home Screen quick action.
export const CONTACT_SOURCE_TAGS = {
  quick_action_delete: "[Deleting]",
} as const

export type ContactSource = keyof typeof CONTACT_SOURCE_TAGS

export function contactSourceTag(value: unknown): string | undefined {
  return typeof value === "string" && Object.prototype.hasOwnProperty.call(CONTACT_SOURCE_TAGS, value)
    ? CONTACT_SOURCE_TAGS[value as ContactSource]
    : undefined
}
